import { SB } from '@play-co/replicant';

/**
 * Schema for day stats
 */
const dayStats = SB.object({
  updatedAt: SB.number(),
  counter: SB.number(),
});

export type DayStatsType = SB.ExtractType<typeof dayStats>;

export default {
  // Save lifetime stats of user activity here
  stats: SB.map(SB.number()),

  // Save day stats of user activity here
  dayStats: SB.map(dayStats),
};
